import './assets/base.pcss';
import {exportConfig, updateConfig} from "./utils/config";
import {debug, error, warn} from "./utils/log";
import {loadCSS} from "./utils/css";
import {checkDependencies} from "./utils/dependency";
import {transformToTranslatableError} from "./utils/error";
import {URL_PREFIX} from "./utils/constants";

// dynamically configure this module based on the URL parameters of the current page
updateConfig(new URLSearchParams(location.search))

function loadFallback(extraConfig: { [key: string]: string }) {
    const c: { [key: string]: string | number | boolean } = {}
    for (const [key, value] of exportConfig()) {
        c[key] = value
    }
    for (const [key, value] of Object.entries(extraConfig)) {
        c[key] = value;
    }
    window.__swssConfig = c;
    const script = document.createElement("script");
    script.src = `${URL_PREFIX}bundle/fallback.js`;
    document.head.appendChild(script)
}

const failedDep = checkDependencies()
if (failedDep) {
    warn(`Dependencies check failed: ${failedDep}`);
    loadFallback({errorId: 'failedDependency', errorMsg: failedDep});
} else {
    debug(`Dependencies check passed.`);
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", bootstrap);
    } else {
        bootstrap().then()
    }
    loadCSS()
}

async function bootstrap() {
    try {
        debug(`bootstrap...`);
        await Promise.all([
            import('@@context').then(m => m.waitForSetup),
            import('./elements/app').then(m => m.injectAutoElement())
        ])
        debug(`bootstrap done...`);
        ;(await import('./integration/integration')).ready()
    } catch (err) {
        error("Failed to bootstrap:", err);
        const e = transformToTranslatableError(err);
        loadFallback({errorId: e.id, errorMsg: e.msg});
    }
}
